import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type ISetCustomsClearanceRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ISetCustomsClearanceRepo = IRepo<[flightId: number | string], ISetCustomsClearanceRepoResponse>;

export const SetCustomsClearanceRepoType = Symbol.for('SetCustomsClearanceRepoType');

@bind(SetCustomsClearanceRepoType)
export class SetCustomsClearanceRepo implements ISetCustomsClearanceRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(flightId: number | string) {
    try {
      const body = new FormData();

      appendToFormData({ flight_id: flightId }, body);

      const url = urlMaker('/api/admin/flights/set-customs-clearance');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 422 || result.status === 400) {
        return {
          status: 400 as 400,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
